import { render } from "./Navigation.vue?vue&type=template&id=a21d2db8&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=a21d2db8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a21d2db8"

export default script